import {Outlet, Navigate} from "react-router-dom";
import {useAuthProvider} from "../../providers/AuthProvider";
function AuthRouter() {
  const {isAuthenticated} = useAuthProvider()
  if (isAuthenticated) {
    return <Navigate to={'/dashboard'}/>
  }
  return <Outlet />}

export default AuthRouter;
